import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    contents: { id: 'lblIconContents', defaultMessage: 'Contents' },
});

const ContentsIcon = React.memo(function ContentsIcon(props: TContentsIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.contents)} {...props}>
            <g clipPath="url(#clip0_20099_27012)">
                <rect x="3.5" y="10.4746" width="10" height="1.5" rx="0.5" />
                <rect x="3.5" y="14.624" width="12.3838" height="1.5" rx="0.5" />
                <rect x="3.5" y="6.32422" width="15" height="1.5" rx="0.5" />
            </g>
            <defs>
                <clipPath id="clip0_20099_27012">
                    <rect width="15" height="9.79996" fill="white" transform="translate(3.5 6.32422)" />
                </clipPath>
            </defs>
        </IconBase>
    );
});

export default ContentsIcon;

// #region Types

export type TContentsIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <ContentsIcon /> : { ...IconBaseExample, render: ContentsIcon };

// #endregion
